import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CleverdatepickerComponent } from './cleverdatepicker.component';
import { AngularMaterialModule } from '@app/material.module';
import { PipeModule } from '@app/pipe/pipe.module';

@NgModule({
    declarations: [
        CleverdatepickerComponent
    ],
    imports: [
        CommonModule,
        PipeModule,
        AngularMaterialModule
    ],
    exports: [
        CleverdatepickerComponent
    ]
})
export class CleverdatepickerModule { }
